import moment from 'moment'

export default {
    numberFormat: (value, decimals) => {
        value = (!value?0:value);
        decimals = (!decimals?0:decimals);
        const rounded =  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return '$ '+rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    percentage: (value) => {
        return Math.round(value) + ' %'
    },
    numeric: (value, decimals) => {
        value = (!value?0:value);
        decimals = (!decimals?0:decimals);
        const rounded =  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return rounded.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    formatDate: (value) => {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY hh:mm a')
        }
    },
    dates: (value) => {
        if (value) {
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    phone: (phone) => {
        if(phone === null){
            return '';
        }
        const soloDigitos = phone.toString().replace(/[^0-9]/g, '');
        const sinSeparadoresTelefono = phone.toString().replace(/[\s+()-]/g, '');
        if(soloDigitos !== sinSeparadoresTelefono){
            // Contiene letras o simbolos (ej. nickname de WhatsApp como @jefflopez), se muestra tal cual
            return phone;
        }
        let valor = soloDigitos;
        while(valor.length < 10){
            valor = "0"+valor;
        }
        return valor.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
}
